/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { useRef } from "react";
import ReactMarkdown from "react-markdown";

import { cssFns } from "@superweb/css";
import { icons, useIsMobile, useTypo, useUiColors } from "@superweb/ui";
import { useLocale } from "@superweb/intl";

import { useMessage } from "#internal/intl";

import { useBrand } from "../router";

import YandexOfferAvifDeprecated from "../images/yandex-offer-deprecated.avif";
import YandexOfferPngDeprecated from "../images/yandex-offer-deprecated.png";
import YandexOfferWebpDeprecated from "../images/yandex-offer-deprecated.webp";
import YandexOfferAvif from "../images/yandex-offer.avif";
import YandexOfferPng from "../images/yandex-offer.png";
import YandexOfferWebp from "../images/yandex-offer.webp";
import YangoOfferAvif from "../images/offer.avif";
import YangoOfferPng from "../images/offer.png";
import YangoOfferWebp from "../images/offer.webp";
import YandexDeliveryOfferAvif from "../images/yandex-delivery-offer.avif";
import YandexDeliveryOfferPng from "../images/yandex-delivery-offer.png";
import YandexDeliveryOfferWebp from "../images/yandex-delivery-offer.webp";
import YangoDeliveryOfferAvif from "../images/yango-delivery-offer.avif";
import YangoDeliveryOfferPng from "../images/yango-delivery-offer.png";
import YangoDeliveryOfferWebp from "../images/yango-delivery-offer.webp";
import YandexMultipleOfferAvif from "../images/yandex-multiple-offer.avif";
import YandexMultipleOfferPng from "../images/yandex-multiple-offer.png";
import YandexMultipleOfferWebp from "../images/yandex-multiple-offer.webp";
import SerbiaOfferPng from "../images/serbia-offer.png";
import SerbiaOfferWebp from "../images/serbia-offer.webp";
import SerbiaOfferAvif from "../images/serbia-offer.avif";

import { LinkButton } from "./link-button";

export const OfferDeprecated = ({
  offerText,
  isDelivery,
  phone,
  messageLink,
  onPhonePress,
  onMessengerPress,
  parkId,
}: {
  offerText?: string;
  isDelivery: boolean;
  phone?: string;
  messageLink?: string;
  onPhonePress: () => void;
  onMessengerPress: () => void;
  parkId?: string;
}) => {
  const message = useMessage();
  const uiColors = useUiColors();
  const typo = useTypo();
  const ref = useRef(null);
  const isMobile = useIsMobile();
  const brand = useBrand();
  const {
    textInfo: { direction },
  } = useLocale();

  const yangoBrand = brand === "yango";

  const imageSrc =
    parkId === "1a1d6c5f1ad7423481a1bc8a8c5d09db"
      ? {
          avif: SerbiaOfferAvif,
          png: SerbiaOfferPng,
          webp: SerbiaOfferWebp,
        }
      : yangoBrand
        ? isDelivery
          ? {
              avif: YangoDeliveryOfferAvif,
              png: YangoDeliveryOfferPng,
              webp: YangoDeliveryOfferWebp,
            }
          : {
              avif: YangoOfferAvif,
              png: YangoOfferPng,
              webp: YangoOfferWebp,
            }
        : isDelivery
          ? {
              avif: YandexDeliveryOfferAvif,
              png: YandexDeliveryOfferPng,
              webp: YandexDeliveryOfferWebp,
            }
          : {
              avif: YandexOfferAvifDeprecated,
              png: YandexOfferPngDeprecated,
              webp: YandexOfferWebpDeprecated,
            };

  return (
    <div
      ref={ref}
      css={{
        display: "grid",
        gridTemplateColumns: isMobile ? undefined : "1fr auto",
        backgroundColor: uiColors.controlMain,
        ...cssFns.border({ radius: "20px" }),
        ...cssFns.padding("16px"),
      }}
    >
      <div
        css={{
          display: "grid",
          gridTemplateRows: offerText ? "1fr auto" : "1fr",
          rowGap: "8px",
          color: yangoBrand ? uiColors.everFront : uiColors.textOnControlMain,
          ...typo({
            level: "body1",
            weight: "medium",
            density: "normal",
          }),
        }}
      >
        {offerText && (
          <ReactMarkdown
            children={offerText.replace(/([^\n])\n([^\n])/g, "$1\n\n$2")}
            components={{
              ul: ({ children }) => (
                <ul
                  css={{
                    paddingInlineStart: "30px",
                    ...cssFns.margin("0"),
                  }}
                >
                  {children}
                </ul>
              ),
              p: ({ children }) => (
                <p css={{ ...cssFns.margin("0"), wordBreak: "break-word" }}>
                  {children}
                </p>
              ),
            }}
            allowedElements={["ul", "li", "p"]}
            unwrapDisallowed
          />
        )}
        {(phone || messageLink) && (
          <div
            css={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              marginInlineStart: "-8px",
              marginBlockEnd: "-4px",
            }}
          >
            {phone && (
              <LinkButton
                link={{ href: `tel:${phone}` }}
                icon={(props) => <icons.CallFill {...props} />}
                text={
                  direction === "rtl" && phone[0] === "+"
                    ? phone.substring(1) + "+"
                    : phone
                }
                onPress={onPhonePress}
              />
            )}
            {messageLink && (
              <LinkButton
                link={{
                  href: messageLink,
                  external: true,
                }}
                icon={(props) => <icons.ChatOutline {...props} />}
                text={message({
                  id: "35526653-51de-4ee3-947c-08ae7b20db91",
                  context:
                    "Yango forms. Contactor deatails. Messеnger link label",
                  default: "Chat with partner",
                })}
                onPress={onMessengerPress}
              />
            )}
          </div>
        )}
      </div>
      {isMobile ? null : (
        <div
          css={{
            ...cssFns.overflow("hidden"),
            width: "100%",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <picture>
            <source src={imageSrc.avif} type="image/avif" />
            <source src={imageSrc.webp} type="image/webp" />
            <img
              css={{
                display: "flex",
                maxWidth: "100%",
                transform: "translateZ(0)",
                objectFit: "contain",
                objectPosition: "center",
                width: isDelivery ? "166px" : "296px",
                height: "132px",
              }}
              width={1161}
              height={521}
              src={imageSrc.png}
              alt={message({
                id: "7e347b54-2aaf-4ba5-bed5-89f34e88a4c3",
                context: "Yango forms. Offer. Image",
                default: "Offer",
              })}
            />
          </picture>
        </div>
      )}
    </div>
  );
};

const yangoImagesMap = {
  delivery: {
    avif: YangoDeliveryOfferAvif,
    png: YangoDeliveryOfferPng,
    webp: YangoDeliveryOfferWebp,
    height: "136px",
    width: "148px",
    padding: "24px",
  },
  taxi: {
    avif: YangoOfferAvif,
    png: YangoOfferPng,
    webp: YangoOfferWebp,
    height: "144px",
    width: "298px",
    padding: "24px",
  },
  multiple: {
    avif: YangoOfferAvif,
    png: YangoOfferPng,
    webp: YangoOfferWebp,
    height: "144px",
    width: "298px",
    padding: "24px",
  },
};
const yandexImagesMap = {
  delivery: {
    avif: YandexDeliveryOfferAvif,
    png: YandexDeliveryOfferPng,
    webp: YandexDeliveryOfferWebp,
    height: "149px",
    width: "152px",
    padding: "16px",
  },
  taxi: {
    avif: YandexOfferAvif,
    png: YandexOfferPng,
    webp: YandexOfferWebp,
    height: "130px",
    width: "178px",
    padding: "24px",
  },
  multiple: {
    avif: YandexMultipleOfferAvif,
    png: YandexMultipleOfferPng,
    webp: YandexMultipleOfferWebp,
    height: "179px",
    width: "284px",
    padding: "0",
  },
};

export const Offer = ({
  offerText,
  type,
  image,
  phone,
  messageLink,
  onPhonePress,
  onMessengerPress,
}: {
  offerText?: string;
  type: "delivery" | "taxi" | "multiple";
  image?: {
    avif: string;
    png: string;
    webp: string;
    height: string;
    width: string;
    padding: string;
  };
  phone?: string;
  messageLink?: string;
  onPhonePress: () => void;
  onMessengerPress: () => void;
}) => {
  const message = useMessage();
  const uiColors = useUiColors();
  const typo = useTypo();
  const isMobile = useIsMobile();
  const brand = useBrand();
  const {
    textInfo: { direction },
  } = useLocale();

  const isYango = brand === "yango";

  const currentImage =
    image ?? (isYango ? yangoImagesMap[type] : yandexImagesMap[type]);

  return (
    <div
      css={{
        display: "grid",
        gridTemplateColumns: isMobile ? undefined : "1fr auto",
        columnGap: "32px",
        backgroundColor: uiColors.controlMain,
        ...cssFns.border({ radius: "20px" }),
        paddingInlineEnd: "32px",
      }}
    >
      <div
        css={{
          display: "grid",
          gridTemplateRows: offerText ? "1fr auto" : "1fr",
          rowGap: "8px",
          color: isYango ? uiColors.everFront : uiColors.textOnControlMain,
          ...typo({
            level: "body1",
            weight: "bold",
            density: "normal",
          }),
          ...cssFns.padding("16px"),
          paddingInlineEnd: "0",
        }}
      >
        {offerText && (
          <ReactMarkdown
            children={offerText.replace(/([^\n])\n([^\n])/g, "$1\n\n$2")}
            components={{
              ul: ({ children }) => (
                <ul
                  css={{
                    paddingInlineStart: "30px",
                    ...cssFns.margin("0"),
                  }}
                >
                  {children}
                </ul>
              ),
              p: ({ children }) => (
                <p css={{ ...cssFns.margin("0"), wordBreak: "break-word" }}>
                  {children}
                </p>
              ),
            }}
            allowedElements={["ul", "li", "p"]}
            unwrapDisallowed
          />
        )}
        {(phone || messageLink) && (
          <div
            css={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              marginInlineStart: "-8px",
              marginBlockEnd: "-4px",
            }}
          >
            {messageLink && (
              <LinkButton
                link={{
                  href: messageLink,
                  external: true,
                }}
                icon={(props) => <icons.ChatOutline {...props} />}
                text={message({
                  id: "5cf895f0-d15d-4b2c-a237-492b3b313f56",
                  context:
                    "Yango forms. Contactor deatails. Messеnger link label",
                  default: "Chat with partner",
                })}
                onPress={onMessengerPress}
              />
            )}
            {phone && (
              <LinkButton
                link={{ href: `tel:${phone}` }}
                icon={(props) => <icons.CallFill {...props} />}
                text={
                  direction === "rtl" && phone[0] === "+"
                    ? phone.substring(1) + "+"
                    : phone
                }
                onPress={onPhonePress}
              />
            )}
          </div>
        )}
      </div>
      {isMobile ? null : (
        <div
          css={{
            ...cssFns.overflow("hidden"),
            width: "100%",
            display: "flex",
            justifyContent: "end",
            ...cssFns.padding(currentImage.padding, "0"),
          }}
        >
          <picture>
            <source src={currentImage.avif} type="image/avif" />
            <source src={currentImage.webp} type="image/webp" />
            <img
              css={{
                display: "flex",
                maxWidth: "100%",
                transform: "translateZ(0)",
                objectFit: "contain",
                objectPosition: "center",
                width: currentImage.width,
                height: currentImage.height,
              }}
              width={1161}
              height={521}
              src={currentImage.png}
              alt={message({
                id: "d060131c-f725-4a00-8475-fc997ac86738",
                context: "Yango forms. Offer. Image",
                default: "Offer",
              })}
            />
          </picture>
        </div>
      )}
    </div>
  );
};
